/** Must match PRODUCT.URL_STUB for the Session registration product in the catalog. */
export const SIGNUP_PRODUCT = 'the-session-2027'
export const EVENT_DATES = '8 - 10 January 2027'
export const STANDARD_TICKET_PRICE = '£190'
export const VIP_TICKET_PRICE = '£290'
